import {useEffect, useRef, useState} from "react";
import {Table} from "antd";
import {getCompleteInvoices} from "../../api/Api";
import {InvoiceStatusType} from "../../api/Constants";
import {InvoiceView} from "./InvoiceView";
import {getColumnSearchProps} from "../widget/SearchProps"

export const NewReturn = ({refresh, onRefresh, onRefreshReturn, onApiFail, props}) => {
    const [invoices, setInvoices] = useState([]);
    // const [messageApi, contextHolder] = message.useMessage();
    const [focusInvoice, setFocusInvoice] = useState(undefined);

    useEffect(() => {
        console.log(`** refreshing invoices ... **`)
        getCompleteInvoices().then(result => {
            console.log(result);
            setInvoices(result.map(i => {
                return {...i,
                    key: i.id
                }
            }));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [refresh, onApiFail]);

    // for use with search props
    const searchInput = useRef(null);

    const columns = [
        {
            title: 'Invoice Number',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber',
            render: (val, record) => {
                return <div style={{cursor: 'pointer'}} onClick={setInvoiceFocus(record)} >
                    {val}
                </div>
            },
            ...getColumnSearchProps('invoiceNumber', searchInput)
        },
        {
            title: 'Buyer',
            dataIndex: 'firstname',
            render: (val, record, index) => {
                return `${val} ${record.lastname}`
            },
            ...getColumnSearchProps('firstname', searchInput)
        },
        {
            title: 'Created by',
            dataIndex: 'username',
            key: 'username'
        },
        {
            title: 'Date',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val) => {
                const terms = val.split("T");
                return terms[0]
            }
        },
        {
            title: 'Status',
            dataIndex: 'state',
            key: 'state',
            render: (val) => {
                return InvoiceStatusType.Label[val];
            }
        },
        {
            title: 'Subtotal',
            dataIndex: 'subtotal',
            key: 'subtotal',
            render: (val) => {
                return `$ ${val}`;
            }
        },
        {
            title: 'Paid',
            dataIndex: 'amountPaid',
            key: 'amountPaid',
            render: (val, record, index) => {
                return <div>$ {val}</div>;
            }
        },
        {
            title: 'Balance',
            dataIndex: 'subtotal',
            key: 'balance',
            render: (val, record, index) => {
                const amount = record.subtotal - record.amountPaid;
                return `$ ${parseFloat(amount.toFixed(2))}`
            }
        }
    ];
    const setInvoiceFocus = (invoice) => () => {
        setFocusInvoice(invoice);
    }
    const onFocusCancel = () => {
        setFocusInvoice(undefined);
    }

    const content = (focusInvoice === undefined) ? <Table dataSource={invoices} columns={columns} /> : <InvoiceView invoice={focusInvoice} onRefresh={onRefreshReturn} onCancel={onFocusCancel}/>

    return <>
        {content}
    </>
}